// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAt5QOXezMSMBzYEFI9vKhX7LOD-T4jtDE",
    authDomain: "malaeb-business.firebaseapp.com",
    projectId: "malaeb-business",
    storageBucket: "malaeb-business.firebasestorage.app",
    messagingSenderId: "923793208859",
    appId: "1:923793208859:web:a9cd446be2687be5052abe",
    measurementId: "G-Z8DC9ZKS86"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const functions = getFunctions(app);

// If you want to use the emulator for local development, uncomment this:
// if (window.location.hostname === 'localhost') {
//   connectFunctionsEmulator(functions, 'localhost', 5001);
// }

export { app, analytics, functions };

